import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BazisInputOptionsComponent } from '@bazis/form/components/base/options/input-options.component';

@Component({
    selector: 'bazis-input-options-card',
    templateUrl: './input-options-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisInputOptionsCardComponent extends BazisInputOptionsComponent {}
